import React from "react";

const ImageInfoCircle = () => {
	return (
		<svg
			className="image-info-circle unclickable"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 20 20"
			enableBackground="new 0 0 20 20"
			xmlSpace="preserve"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				fill="#00B7BD"
				d="M10,0c5.5,0,10,4.5,10,10s-4.5,10-10,10S0,15.5,0,10S4.5,0,10,0z
                M10,1c-5,0-9,4-9,9s4,9,9,9s9-4,9-9S15,1,10,1z M9.2,15V8.3h1.7V15H9.2z M9,6c0-0.5,0.4-1,1.1-1c0.6,0,1.1,0.4,1.1,1s-0.5,1-1.1,1
                C9.4,7,9,6.5,9,6z"
			/>
		</svg>
	);
};

export default ImageInfoCircle;
